import { ITEMS_CATEGORIES, ITEMS_RARITY, ItemTemplate } from "../constants";

export default {
    type: "avatars",
    listData: [{
        "key": "name",
        "label": "Name",
    }, {
        "key": "rarity",
        "label": "Rarity",
    }, {
        "key": "group",
        "label": "Category",
    }],
    template: [{
        "key": "name",
        "label": "Name",
        "type": "input",
    }, {
        "key": "game_id",
        "label": "Game Id",
        "type": "input",
    }, {
        "key": "group",
        "label": "Category",
        "type": "select",
        "values": ITEMS_CATEGORIES
    }, {
        "key": "rarity",
        "label": "Rarity",
        "type": "select",
        "values": ITEMS_RARITY
    }]
} as ItemTemplate;
